export default __webpack_public_path__ + "static/media/01bg.d447d5b4.png";